import React from 'react';
import { Box, Button } from '@mui/material';

export interface CategoryDict {
  id: string;
  name: string;
}

const CATEGORIES: CategoryDict[] = [
  { id: 'ANSWERING', name: 'Answering' },
  { id: 'ADDRESS_CHANGE', name: 'Address Change' },
  { id: 'MORE_INFORMATION', name: 'More Information' },
  { id: 'ORDER_CANCEL', name: 'Order Cancel' },
  { id: 'ORDER_TRACKING', name: 'Order Tracking' },
  { id: 'PRODUCTS', name: 'Products' },
  { id: 'RETURNS_REPLACEMENTS_REFUNDS', name: 'Returns, Replacements and Refunds' }
];

interface CategorySelectorProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
}

const CategorySelector: React.FC<CategorySelectorProps> = ({
  selectedCategory,
  onCategoryChange
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {CATEGORIES.map((categoryDict) => (
        <Button
          key={categoryDict.id}
          variant={selectedCategory === categoryDict.id ? 'contained' : 'outlined'}
          onClick={() => onCategoryChange(categoryDict.id)}
          size="small"
        >
          {categoryDict.name}
        </Button>
      ))}
    </Box>
  );
};

export default CategorySelector;
